"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServicesTypeGroup = exports.isMetaTypeGroup = exports.isMasterTypeGroup = exports.isContentTypeGroup = exports.isAttributesTypeGroup = void 0;
var attributes_1 = require("./attributes");
Object.defineProperty(exports, "isAttributesTypeGroup", { enumerable: true, get: function () { return attributes_1.isAttributesTypeGroup; } });
var content_1 = require("./content");
Object.defineProperty(exports, "isContentTypeGroup", { enumerable: true, get: function () { return content_1.isContentTypeGroup; } });
var master_1 = require("./master");
Object.defineProperty(exports, "isMasterTypeGroup", { enumerable: true, get: function () { return master_1.isMasterTypeGroup; } });
var meta_1 = require("./meta");
Object.defineProperty(exports, "isMetaTypeGroup", { enumerable: true, get: function () { return meta_1.isMetaTypeGroup; } });
__exportStar(require("./services"), exports);
var services_1 = require("./services");
Object.defineProperty(exports, "isServicesTypeGroup", { enumerable: true, get: function () { return services_1.isServicesTypeGroup; } });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdHlwZXMvdHlwZS1ncm91cHMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSwyQ0FBeUU7QUFBM0MsbUhBQUEscUJBQXFCLE9BQUE7QUFDbkQscUNBQWdFO0FBQXJDLDZHQUFBLGtCQUFrQixPQUFBO0FBQzdDLG1DQUE2RDtBQUFuQywyR0FBQSxpQkFBaUIsT0FBQTtBQUMzQywrQkFBdUQ7QUFBL0IsdUdBQUEsZUFBZSxPQUFBO0FBQ3ZDLDZDQUEwQjtBQUMxQix1Q0FBbUU7QUFBdkMsK0dBQUEsbUJBQW1CLE9BQUEifQ==